import { render } from "./ButtonCheckbox.vue?vue&type=template&id=fa189488"
import script from "./ButtonCheckbox.vue?vue&type=script&lang=js"
export * from "./ButtonCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__